export class Page {
  public pageId: string;
  public pageNo: number = 1; // 当前页初始值
  public totals: number; // 总数
  public pageSize: number = 10; // 每页显示初始值

  constructor() {
  }
}



// WEBPACK FOOTER //
// E:/java/gd-project/credit-gd-web/src/app/models/page.ts